module.exports = {"en":"Anglais","fr":"Français"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/locales.json
// module id = GD7J
// module chunks = 0